import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { z } from 'zod';

import { queryCountry } from 'src/api/queries';
import { ConnectOfferCheckoutPage } from 'src/apps/checkout/app/pages/ConnectOffer.Checkout';

import { maybeRedirectCheckoutEntrypointToV2 } from './-checkoutV2EntrypointRedirect';

const searchSchema = z.object({
  redirect_status: z.string().optional(),
});

export const Route = createFileRoute(
  '/_auth/_only-header/store/connect-offer/_allowed/checkout'
)({
  validateSearch: zodValidator(searchSchema),
  beforeLoad: ({ context, search }) => {
    maybeRedirectCheckoutEntrypointToV2({
      featureFlags: context.featureFlags,
      search,
    });
  },
  loader: async ({ context }) =>
    context.queryClient.ensureQueryData(queryCountry()),
  component: () => <ConnectOfferCheckoutPage />,
});
